//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "PopOver",
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    options: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: "-----",
    },
    objKey: {
      type: String,
      default: "key",
    },
    objValue: {
      type: String,
      default: "value",
    },
    internationalization: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      popoverOpened: false,
      selectedOption: null,
    };
  },
  created() {
    const selectedOption = this.options.find(
      (opt) => String(opt.value) === String(this.value.value),
    ) ?? {
      key: null,
      value: null,
    };
    this.selectedOption = selectedOption;
    this.$options.originalValue = selectedOption;
  },
  methods: {
    onClick(option) {
      this.selectedOption = option;
      this.$emit("input", this.selectedOption);
      this.$emit("hasChanged", this.$options.originalValue.key !== this.selectedOption.key);
    },
  },
};
